export default "__VITE_ASSET__CiKC1iYS__"